<script setup>
import { useAttrs, computed, ref, onMounted, onUnmounted } from 'vue';
import logoUrl from 'assets/images/leadster-logo-v2.webp';
import logoWhiteUrl from 'assets/images/leadster-logo-v2-white.webp';

const props = defineProps({
  type: {
    type: String,
    default: null,
    validator: value => ['light', 'dark'].includes(value),
  },
});

const attrs = useAttrs();

const el = ref(null);
const isDark = ref(false);

let observer = null;

const detectDark = () => {
  isDark.value = !!el.value?.closest('.dark');
};

onMounted(() => {
  detectDark();

  observer = new MutationObserver(detectDark);

  observer.observe(document.documentElement, {
    attributes: true,
    attributeFilter: ['class'],
    subtree: true,
  });
});

onUnmounted(() => {
  if (observer) {
    observer.disconnect();
  }
});

const currentLogo = computed(() => {
  if (props.type === 'light') {
    return logoUrl;
  }
  if (props.type === 'dark') {
    return logoWhiteUrl;
  }
  return isDark.value ? logoWhiteUrl : logoUrl;
});
</script>

<template>
  <img ref="el" v-bind="attrs" :src="currentLogo" alt="Leadster" />
</template>
